import AnnuityRefund from "../../modules/annuity-refund/views/AnnuityRefund.vue";
import RouterViewRender from "../../utils/routes/router-view-render";

const AnnuityRefundRoutes = {
  path: "reembolso-anuidade",
  component: RouterViewRender,
  children: [
    {
      path: "",
      component: AnnuityRefund,
      meta: {
        requiresAuth: true,
      },
    }
  ],
};

export default AnnuityRefundRoutes;
